import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

type UseCreateAuditCommentsReplyPayload = { reply: string };

type UseCreateAuditCommentsReplyProps = {
  commentId: string;
  encounterId: string;
  chartCode: string;
  sectionCode: string;
  subsectionCode?: string;
};

function useCreateAuditCommentsReply({
  commentId,
  encounterId,
  chartCode,
  sectionCode,
  subsectionCode,
}: UseCreateAuditCommentsReplyProps) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    [
      "createAuditCommentsReply",
      { encounterId, chartCode, sectionCode, subsectionCode },
    ],
    (input: UseCreateAuditCommentsReplyPayload) => {
      const endpoint = subsectionCode
        ? `/v1/audits/subsection/comments/reply/${commentId}`
        : `/v1/audits/section/comments/reply/${commentId}`;
      return axiosChartInstance.put(endpoint, input);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "AuditComments",
          { encounterId, chartCode, sectionCode, subsectionCode },
        ]);
        queryClient.invalidateQueries([
          "AuditCommentsReplySubsectionIndicator",
          { encounterId, chartCode, sectionCode, subsectionCode },
        ]);
      },
    }
  );
}

type UseCreateAuditCommentsSharedReplyProps = {
  commentId: string;
  encounterId: string;
  sectionCode: string;
  subsectionCode?: string;
};

function useCreateAuditCommentsSharedReply({
  commentId,
  encounterId,
  sectionCode,
  subsectionCode,
}: UseCreateAuditCommentsSharedReplyProps) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    [
      "createAuditCommentsReplyShared",
      { encounterId, sectionCode, subsectionCode },
    ],
    (input: UseCreateAuditCommentsReplyPayload) => {
      const endpoint = subsectionCode
        ? `/v1/audits/subsection/comments/reply/${commentId}`
        : `/v1/audits/section/comments/reply/${commentId}`;
      return axiosChartInstance.put(endpoint, input);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "AuditCommentsShared",
          { encounterId, sectionCode, subsectionCode },
        ]);
      },
    }
  );
}

export type { UseCreateAuditCommentsReplyPayload };
export { useCreateAuditCommentsReply, useCreateAuditCommentsSharedReply };
